<div class="chart-wrapper" data-testid="issues-chart-container">
  <div class="chart-container" data-testid="issues-chart-canvas-container">
    <canvas baseChart [data]="chartData" [type]="chartType" [options]="chartOptions">
    </canvas>
    <div class="chart-total-text" data-testid="issues-chart-total">{{total}}</div>
  </div>

  <div class="custom-legend" data-testid="issues-chart-legend">
    <div class="legend-item" *ngIf="minor > 0" data-testid="issues-chart-legend-minor">
      <span class="color-bar minor"></span>
      <div class="legend-text">
        <label>Minor</label>
        <span class="value" data-testid="issues-chart-minor-count">{{ pad(minor) }}</span>
      </div>
    </div>

    <div class="legend-item" *ngIf="major > 0" data-testid="issues-chart-legend-major">
      <span class="color-bar major"></span>
      <div class="legend-text">
          <label>Major</label>
          <span class="value" data-testid="issues-chart-major-count">{{ pad(major) }}</span>
      </div>
    </div>

    <div class="legend-item" *ngIf="missing > 0" data-testid="issues-chart-legend-missing">
      <span class="color-bar missing"></span>
      <div class="legend-text">
        <label>Missing</label>
        <span class="value" data-testid="issues-chart-missing-count">{{ pad(missing) }}</span>
      </div>
    </div>
  </div>

</div>
